var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 124,
    viewBox: "0 0 97 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6328 43.168H74.3661H22.6328ZM22.6328 107.835H74.3661H22.6328ZM29.0995 43.168V62.568L43.6495 78.7346M67.8995 107.835V84.393L53.3495 70.6513M29.0995 107.835V85.2013L39.6078 74.693",
    fill: "#EEF9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6328 43.168H74.3661M22.6328 107.835H74.3661M29.0995 43.168V62.568L43.6495 78.7346M67.8995 107.835V84.393L53.3495 70.6513M29.0995 107.835V85.2013L39.6078 74.693",
    stroke: "#4DBBFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8969 43.168V62.568L57.3885 74.693M38.7969 90.0513H40.4135H38.7969ZM56.8179 89.4806L57.9608 90.6236L56.8179 89.4806ZM48.4969 98.1346H50.1135H48.4969Z",
    fill: "#EEF9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8969 43.168V62.568L57.3885 74.693M38.7969 90.0513H40.4135M56.8179 89.4806L57.9608 90.6236M48.4969 98.1346H50.1135",
    stroke: "#4DBBFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sandClock.ad03984c124b8b57a4daca10f9791796.svg";
export { ForwardRef as ReactComponent };